import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Angulartics2Module } from 'angulartics2';

import { MyRemaxMenuComponent } from './my-remax-menu.component';

import { CircleInitialsModule } from '../../circle-initials/circle-initials.module';

import { SharedDirectivesModule } from '../../../shared/directives/shared-directives.module';
import { SharedPipesModule } from '../../../shared/pipes/shared-pipes.module';


@NgModule({
    imports: [
        Angulartics2Module,
        CircleInitialsModule,
        CommonModule,
        RouterModule,
        SharedDirectivesModule,
        SharedPipesModule,
        TranslateModule.forChild()
    ],
    declarations: [
        MyRemaxMenuComponent
    ],
    exports: [
        MyRemaxMenuComponent
    ]
})
export class MyRemaxMenuModule { }
